.promptArrow {
  background: var(--colors-grays-white);
  border: 1px solid var(--colors-grays-light);
  border-radius: 2px;
  position: absolute;
  height: 12px;
  width: 12px;
  top: 2px;
  left: 2px;
  transform: rotate(45deg);
}

.dismissButton {
  position: absolute;
  top: 15px;
  right: 15px;
}

/* Prompt is currently only used on desktop (for login prompt) */
.promptContainer {
  display: none;
}

@media all and (--reefer-media-tablet-min) {
  .promptContainer {
    display: block;
    z-index: var(--layers-popover);
    position: absolute;
    top: 50px;
    right: -133px;
    width: 320px;
  }
}
